import type { OrganizationStatus } from "@/api/types/marketplace";

export type VendorZone = "onboard" | "suspended" | "rejected" | "portal";

/**
 * Map organization status to the single zone the vendor UI may render.
 * Unexpected / missing statuses fall through to onboard.
 */
export function resolveAllowedZone(status: OrganizationStatus): VendorZone {
  if (status === "ACTIVE") return "portal";
  if (status === "SUSPENDED") return "suspended";
  if (status === "REJECTED") return "rejected";
  // PENDING_ONBOARDING, CHANGES_REQUESTED, or any unexpected value → onboard
  return "onboard";
}

/** When approval is PENDING, lock the wizard to the pending page. */
export function resolveOnboardTarget(pendingApproval: boolean): string {
  return pendingApproval ? "/onboard/pending" : "/onboard";
}

/**
 * Resolve the zone after the onboarding status query settles.
 * Query errors force onboard so the vendor can recover.
 */
export function resolveVendorZone(
  status: OrganizationStatus | undefined,
  isError: boolean,
): VendorZone {
  if (isError) return "onboard";
  return resolveAllowedZone(status ?? "PENDING_ONBOARDING");
}
